import {
  FleetEntryWithMileage,
  useGetFleetEntriesWithMileage,
  UseGetFleetEntriesWithMileageInput,
} from "../../api/rebates/useGetFleetEntriesWithMileage"
import { usePolicyAndFleet } from "../PolicyAndFleetProvider"
import { useApiForArray } from "./useApiForArray"

export const useFleetEntriesWithMileage = () => {
  const { policy, connectivity } = usePolicyAndFleet()
  const [res, reload] = useGetFleetEntriesWithMileage({
    connectedVrns: connectivity.data?.connectedVrns ?? [],
    id: policy.id as string,
  })
  return useApiForArray<FleetEntryWithMileage, UseGetFleetEntriesWithMileageInput>(res, reload)
}
